// src/pages/Users/Techniques/components/SkeletonCard.jsx

import React from "react";

export default function SkeletonCard() {
  return (
    <div className="overflow-hidden rounded-[1.65rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="aspect-[551/617] animate-pulse bg-slate-200 dark:bg-slate-800" />

      <div className="space-y-2 p-3">
        <div className="h-4 w-4/5 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
        <div className="h-3 w-2/3 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
        <div className="hidden h-3 w-full animate-pulse rounded-full bg-slate-200 dark:bg-slate-800 sm:block" />
        <div className="hidden h-3 w-3/4 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800 sm:block" />

        <div className="grid grid-cols-2 gap-2 pt-2">
          <div className="h-10 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
          <div className="h-10 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
        </div>
      </div>
    </div>
  );
}